import {Account} from "../../accounts/Account";

const isBudgetedAccountTransfer = (sourceAccount: Account, targetAccount: Account) => {
    return (!sourceAccount.isOffBudget && !targetAccount.isOffBudget);
}

export default isBudgetedAccountTransfer;